import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import {
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import { actions } from 'react-redux-form';

import {
  navigate,
  tradeSecurityInfo,
} from '../../actions';

import TradeForm from './TradeForm';
import TradeReview from './TradeReview';
import TradeConfirm from './TradeConfirm';
import OrderPayment from './OrderPayment';

import DisclaimerViews from './DisclaimerViews';

import {
  tradeSecurityPath,
  tradeOrderTypePath,
  tradeSecurityTransferPath,
} from '../Forms/Schemas/baseRrf';

export const TRADE_TYPE = Object.freeze({ BUY: 'BUY', SELL: 'SELL' });
export const getRoutes = (type, ticker) => {
  const dir = type === TRADE_TYPE.BUY ? 'Buy' : 'Sell';
  return ([
    {
      step: `${dir} ${ticker}`,
      path: 'trade',
      Comp: TradeForm,
    },
    {
      step: 'Payment',
      path: 'payment',
      Comp: OrderPayment,
    },
    {
      step: `Review ${dir} Order`,
      path: 'review',
      Comp: TradeReview,
    },
    {
      step: 'Order Confirmed',
      path: 'confirmed',
      Comp: TradeConfirm,
    },
  ]);
};

class SecurityTradeContainer extends Component {
  constructor(props) {
    super(props);
    const {
      positions,
      tradeDir,
      securityId,
      tradeInfo,
    } = props;
    const position = positions.filter(pos => (get(pos, 'security.ticker') === securityId))[0];
    if (get(tradeInfo, 'tradeDir', '') !== tradeDir || get(tradeInfo, 'ticker', '') !== securityId) {
      this.props.addTradeSecurityInfo({
        tradeDir,
        ticker: securityId,
      });
      this.props.resetTradeSecurityForm();
      this.props.resetTradeOrderTypeForm();
      this.props.resetTradeSecurityTransferForm();
    }
    this.state = {
      routes: getRoutes(tradeDir, securityId),
      isSecurityHeld: !!position,
      securityQtyHeld: get(position, 'shareQuantity', 0),
    };
  }

  onNext = async () => {
    const { match } = this.props;
    const nextRoute = this.getNextRoute();
    if (nextRoute) {
      this.props.navigate(`${match.url}/${nextRoute.path}`);
    }
  }

  getRouteIndex = (props) => {
    const { match, location } = props || this.props;
    const { routes } = this.state;
    const curPath = location.pathname.replace(new RegExp(`^${match.url}/`), '');
    return routes.findIndex(route => route.path === curPath);
  }

  getPreviousRoute = props => this.state.routes[this.getRouteIndex(props) - 1];
  getRoute = props => this.state.routes[this.getRouteIndex(props)];
  getNextRoute = props => this.state.routes[this.getRouteIndex(props) + 1];

  render() {
    const {
      match,
      securityId,
      tradeDir,
      priceData,
    } = this.props;
    const {
      routes,
      isSecurityHeld,
      securityQtyHeld,
    } = this.state;
    const routeIndex = this.getRouteIndex(this.props);
    const backTo = routeIndex === 0 ? `/securities/${securityId}` :
      get(this.getPreviousRoute(this.props), 'path');
    const propsToPassToComponent = {
      currentPrice: get(priceData, 'last', null),
      onNext: this.onNext,
      backTo,
      securityId,
      securityQtyHeld,
      tradeDir,
    };
    const disclaimerPropsTrade = {
      backTo: `${match.url}/trade`,
      backLabel: 'Edit Order',
      offerId: match.params.offerId,
    };
    const disclaimerPropsReview = {
      backTo: `${match.url}/review`,
      backLabel: 'Review Order',
      offerId: match.params.offerId,
    };
    return (
      <div>
        {isSecurityHeld || routeIndex === 3 ?
          <Switch>
            <Route
              path={`${match.url}/order-type-trade`}
              render={() => (
                <DisclaimerViews
                  view="orderType"
                  {...disclaimerPropsTrade}
                />)}
            />
            <Route
              path={`${match.url}/expiration-trade`}
              render={() => (
                <DisclaimerViews
                  view="expiration"
                  {...disclaimerPropsTrade}
                />)}
            />
            <Route
              path={`${match.url}/service-fee-trade`}
              render={() => (
                <DisclaimerViews
                  view="serviceFee"
                  {...disclaimerPropsTrade}
                />)}
            />
            <Route
              path={`${match.url}/order-information-review`}
              render={() => (
                <DisclaimerViews
                  view="orderInformation"
                  {...disclaimerPropsReview}
                />)}
            />
            <Route
              path={`${match.url}/order-type-review`}
              render={() => (
                <DisclaimerViews
                  view="orderType"
                  {...disclaimerPropsReview}
                />)}
            />
            <Route
              path={`${match.url}/expiration-review`}
              render={() => (
                <DisclaimerViews
                  view="expiration"
                  {...disclaimerPropsReview}
                />)}
            />
            <Route
              path={`${match.url}/service-fee-review`}
              render={() => (
                <DisclaimerViews
                  view="serviceFee"
                  {...disclaimerPropsReview}
                />)}
            />
            {routes.map(({ path, Comp, step }) => (Comp ?
              <Route
                key={path}
                exact
                path={`${match.url}/${path}`}
                render={props =>
                  (<Comp
                    {...props}
                    {...propsToPassToComponent}
                    title={step}
                  />)}
              /> : null
            ))}
            {routes[0] && routes[0].path ? <Redirect to={`${match.url}/${routes[0].path}`} /> : null}
          </Switch> : <div>Security Not Found</div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state, {
  match: {
    params: {
      tradeDir,
      securityId,
    },
  },
}) => ({
  cashBalance: Number.parseFloat(get(state.accountCashBalanceByAccount[state.currentAccount], 'data.balanceAvailableForT1Trades')),
  accountNumber: state.currentAccount,
  tradeDir,
  priceData: get(state, `quoteData['${securityId}'].pricedata`),
  positions: get(state, `accountPositionsByAccount[${get(state, 'currentAccount', '')}].data`, []),
  securityId,
  tradeInfo: get(state, 'tradeSecurityInfo.tradeInfo'),
});

const mapDispatchToProps = dispatch => ({
  navigate: (...args) => (dispatch(navigate(...args))),
  addTradeSecurityInfo: (...args) => (dispatch(tradeSecurityInfo(...args))),
  resetTradeSecurityForm: () => (dispatch(actions.reset(tradeSecurityPath))),
  resetTradeOrderTypeForm: () => (dispatch(actions.reset(tradeOrderTypePath))),
  resetTradeSecurityTransferForm: () => (dispatch(actions.reset(tradeSecurityTransferPath))),
});

export default connect(mapStateToProps, mapDispatchToProps)(SecurityTradeContainer);



// WEBPACK FOOTER //
// ./src/components/SecurityTrade/index.js